import InstitutionExpectedActivityForm from '@/features/institution/expected-activity/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingExpectedActivityPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="expectedActivity" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionExpectedActivityForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingExpectedActivityPage.displayName = 'InstitutionOnboardingExpectedActivityPage';

export default InstitutionOnboardingExpectedActivityPage;
